import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { actions } from '../../store/auth';
import svc from 'svc';



class Logout extends React.PureComponent {

	componentDidMount = () => {
		// The login form briefly appears if we don't wait for CSSTransition to finish.
		setTimeout( this.logout, 500 );
	};


	logout = () => {
		this.props.setAuth( {
			sid: null,
			token: null,
			pending: false,
			authenticated: false,
		} );
		localStorage.removeItem( 'token' );
		localStorage.removeItem( 'sid' );
		localStorage.removeItem( 'appData' );
		localStorage.removeItem( 'appDataHash' );
		svc.close();
		if(window.svc) window.svc = null;
	};


	render() {
		return (
			<div>
				You have been logged out. Click <Link to='/'>here</Link> to log in again.
			</div>
		)
	}

}



const mapDispatchToProps = dispatch => {
	return {
		setAuth: ( data ) => {
			dispatch( actions.setAuth( data ) );
		},
	}
};


export default connect( null, mapDispatchToProps )( Logout );

